import { Link } from "react-router-dom";
import { site } from "../data/site";
import { useT } from "../data/i18n";

export const Footer = () => {
  const { t } = useT();
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="header-logo" style={{ marginBottom: 14 }}>
              Yasmina <span className="dot" />
            </div>
            <p style={{ maxWidth: 360 }}>{t("footer_tagline")}</p>
          </div>
          <div>
            <h4>{t("footer_contact")}</h4>
            <p>{site.address}</p>
            <p><a href={`mailto:${site.email}`} data-testid="footer-email">{site.email}</a></p>
            <p><a href={site.mapLink} target="_blank" rel="noreferrer" data-testid="footer-map-link">{t("btn_map")}</a></p>
          </div>
          <div>
            <h4>{t("footer_nav")}</h4>
            <p><Link to="/">{t("nav_home")}</Link></p>
            <p><Link to="/carta">{t("nav_menu")}</Link></p>
            <p><Link to="/sobre-nosotros">{t("nav_about")}</Link></p>
            <p><Link to="/blog">{t("nav_blog")}</Link></p>
            <p><Link to="/contacto">{t("nav_contact")}</Link></p>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 Yasmina — {t("footer_bottom")}</span>
          <span>{t("footer_region")}</span>
        </div>
      </div>
    </footer>
  );
};
